import React from 'react';

class Metadata extends React.Component {
  render() {
    const {
      meta,
      translation_name,
      translation_started,
      translation_completed
    } = this.props;

    return (
      <dl className="metadata">
        <dt id="metadata-name" className="metadata__term">
          {translation_name}
        </dt>
        <dd className="metadata__value" aria-labelledby="metadata-name">
          {meta.name}
        </dd>
        <dt id="metadata-started" className="metadata__term">
          {translation_started}
        </dt>
        <dd className="metadata__value" aria-labelledby="metadata-started">
          {meta.date_started}
        </dd>
        <dt id="metadata-completed" className="metadata__term">
          {translation_completed}
        </dt>
        <dd className="metadata__value" aria-labelledby="metadata-completed">
          {meta.date_completed}
        </dd>
      </dl>
    );
  }
}

export default Metadata;
